import { render, staticRenderFns } from "./du-service-template.vue?vue&type=template&id=7a4f4659&"
import script from "./du-service-template.vue?vue&type=script&lang=js&"
export * from "./du-service-template.vue?vue&type=script&lang=js&"
import style0 from "./du-service-template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports